import script from "./FriendsSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./FriendsSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./FriendsSidebar.vue?vue&type=style&index=0&id=70333bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70333bdc"]])

export default __exports__